import Default404 from "../components/Default404/Default404";

const PageNotFound = () => {
  return <Default404 />;
};

export default PageNotFound;
